import HeroLP from './components/HeroLP';
import WhyItWorks from './components/WhyItWorks';
import TestimonialsLP from './components/TestimonialsLP';

const ICLOSED_URL = 'https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin';

export default function LP() {
  return (
    <div style={{ background: '#111111', minHeight: '100vh' }}>
      <title>Transformez votre site en machine à leads | Usine à Leads</title>
      <meta
        name="description"
        content="Votre site est en ligne mais ne vous rapporte rien ? Usine à Leads transforme votre site en système de génération de leads qualifiés. +47% de leads en 90 jours. Diagnostic offert 45 min."
      />
      <meta name="keywords" content="génération de leads, leads qualifiés, système automatisé, rendez-vous qualifiés" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://usineleads.com/" />

      <HeroLP />
      <WhyItWorks />
      <TestimonialsLP />

      {/* Footer minimal dark */}
      <footer
        className="w-full py-8 px-8 md:px-16"
        style={{ borderTop: '1px solid rgba(255,255,255,0.08)', background: '#0d0d0d' }}
      >
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
            © {new Date().getFullYear()} Usine à Leads — Marc Signorel. Tous droits réservés.
          </span>
          <div className="flex items-center gap-6 text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
            <a href="/mentions-legales" className="hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer">
              Mentions légales
            </a>
            <a href="/politique-de-confidentialite" className="hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer">
              Confidentialité
            </a>
            <a href="/cgv" className="hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer">
              CGV
            </a>
            <button
              data-iclosed-link={ICLOSED_URL}
              data-embed-type="popup"
              className="hover:opacity-70 transition-opacity whitespace-nowrap cursor-pointer border-none bg-transparent p-0 text-xs"
              style={{ color: '#C8922A' }}
            >
              Accéder au diagnostic →
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}
